import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from '@mui/icons-material';

interface SectionVisibilityToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  label?: string;
}

const SectionVisibilityToggle: React.FC<SectionVisibilityToggleProps> = ({
  enabled,
  onChange,
  label = 'Bölüm Görünürlüğü',
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
      mb: 2,
      p: 1.5,
      borderRadius: 1,
      border: '1px solid',
      borderColor: enabled ? 'success.light' : 'warning.light',
      backgroundColor: enabled ? 'success.50' : 'warning.50',
      transition: 'background-color 150ms ease, border-color 150ms ease',
    }}
  >
    <Box>
      <Typography variant="subtitle2" fontWeight={600}>
        {label}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {enabled ? 'Bu bölüm sitede gösterilir.' : 'Bu bölüm sitede gizlenir (ziyaretçilere gösterilmez).'}
      </Typography>
    </Box>
    <Button
      size="small"
      variant={enabled ? 'contained' : 'outlined'}
      color={enabled ? 'success' : 'warning'}
      startIcon={enabled ? <VisibilityIcon /> : <VisibilityOffIcon />}
      onClick={() => onChange(!enabled)}
      sx={{ flexShrink: 0 }}
    >
      {enabled ? 'Görünür' : 'Gizli'}
    </Button>
  </Box>
);

export default SectionVisibilityToggle;
